<template>
    <div>
        <div class="d-flex justify-center">
            <img :src="volvicImage" alt="Soirée Volvic 50 ans" class="banniere_volvic">
        </div>
        <div>
            <div class="text-h5 font-weight-bold mb-2 text-center text-uppercase">Soirée génération VOLVIC</div>
            <div class="text-h5 font-weight-bold mb-2 text-center">- 17 MAI 2025 -</div>
            <div>A l'occasion des 50 ans du Chancet, nous proposons un moment de convivialité
                autour d'un cocktail
                dinatoire.</div>
            <div class="font-weight-bold mt-3 mb-2 text-uppercase">Infos pratiques:</div>
            <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Adresse : Usine du Goulet,
                rue des
                Sources 63 530 VOLVIC</div>
            <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Invitation : Valable pour 2
                personnes -
                à partir de 19h30 (les enfants ne sont pas
                autorisés)</div>

            <div class="mb-2"><v-icon icon="mdi-square-small" color="primary-dark"></v-icon>Fermeture des inscriptions
                le
                07/05/2025</div>
        </div>
        <hr>
    </div>
</template>

<script>
import volvicImage from '@/assets/img/volvic_50_noborder.jpg'

export default {
    data() {
        return {
            volvicImage
        }
    }
}
</script>

<style lang="scss" scoped>
.banniere_volvic {
    width: 100%;
    height: auto;
    border-radius: 3px;
    margin: 0 15px 15px 15px;
}
</style>